'use strict';

module.exports = function () {
    return {
        framework: 'bulma',
        table: 'table is-bordered is-striped is-hoverable is-fullwidth',
        row: 'columns',
        column: 'column is-12',
        label: 'label',
        input: 'input',
        select: 'select',
        field: 'field',
        inline: 'is-horizontal',
        right: 'is-pulled-right',
        left: 'is-pulled-left',
        center: 'has-text-centered',
        contentCenter: 'is-centered',
        icon: 'icon',
        small: 'is-small',
        nomargin: 'marginless',
        button: 'button',
        groupTr: 'is-selected',
        dropdown: {
            container: 'dropdown',
            trigger: 'dropdown-trigger',
            menu: 'dropdown-menu',
            content: 'dropdown-content',
            item: 'dropdown-item',
            caret: 'fa fa-angle-down'
        },
        pagination: {
            nav: '',
            count: '',
            wrapper: 'pagination',
            list: 'pagination-list',
            item: '',
            link: 'pagination-link',
            next: '',
            prev: '',
            active: 'is-current',
            disabled: ''
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/themes/bulma.js
// module id = 1008
// module chunks = 0